import { z } from 'zod';
import { MediaSchema } from './medias.js';
import { DateCivileSchema, ProseBilingueSchema, SlugSchema, TexteBilingueSchema, } from './textes.js';
export const ActualiteSchema = z.object({
    slug: SlugSchema,
    titre: TexteBilingueSchema,
    date: DateCivileSchema,
    /** Chapô : sert de description `<meta>`, d'accroche de liste et de RSS. */
    chapo: TexteBilingueSchema,
    texte: ProseBilingueSchema,
    media: MediaSchema.optional(),
    /** Rattachements facultatifs, rendus en liens vers des pages produites. */
    artistes: z.array(SlugSchema),
    expositions: z.array(SlugSchema),
});
//# sourceMappingURL=actualites.js.map